import React, { useState, useEffect, useCallback } from "react";

import { connect } from "react-redux";
import { push } from "react-router-redux";

export const NotFound = (props) => {
  const { goTo } = props;

  const [time, setTime] = useState(10);

  const redirect = useCallback(() => {
    goTo("/");
  }, [goTo]);

  useEffect(() => {
    const redirectTimeCounting = setInterval(() => {
      if (time > 0) {
        setTime((prev) => prev - 1);
      } else {
        redirect();
      }
    }, 1000);

    return () => clearInterval(redirectTimeCounting);
  }, [redirect, time]);

  return (
    <>
      <div className={"authorized-header"}>
        <button onClick={redirect} className={"authorized-header__button"}>
          <div className={"page-header-left-text"}>{"Wróć"}</div>
        </button>
      </div>
      <div className="authorized-content">
        <div className="authorized-content__inner">
          <div className="authorized-content__title">
            Strona o podanym adresie nie istnieje
          </div>
          <div className="authorized-content__subTitle">
            Za chwilę program powróci do strony głównej, pozostało sekund:{" "}
            {time}
          </div>
          <i className={"fas fa-lock authorized-content__icon"} />
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...{ goTo: (url) => dispatch(push(url)) },
  };
};

export default connect(undefined, mapDispatchToProps)(NotFound);
